import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-prueflauf';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksVeranstaltungPrueflaufEffects {

    VeranstaltungPrueflauf$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_PRUEFLAUF),
        mergeMap((x: ac.GetVeranstaltungPrueflaufAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungPrueflauf(x.prueflaufRequest).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungPrueflaufErfolgreichAction(result, x.prueflaufRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungPrueflaufFehlerAction(error, x.prueflaufRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufQueryService);
        }
        return this.service;
    }
}
